import { createStore, applyMiddleware, compose } from "redux"
import createSagaMiddleware from "redux-saga"
import { persistStore, persistReducer } from "redux-persist"
import storage from "redux-persist/lib/storage"

import rootReducer from "./reducers"
import rootSaga from "./sagas"

// Configuration for redux-persist
const persistConfig = {
  key: "root",
  storage,
}

// Create a persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer)

const sagaMiddleware = createSagaMiddleware()
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

// Create the store using the persisted reducer
const store = createStore(
  persistedReducer,
  composeEnhancers(applyMiddleware(sagaMiddleware)),
)

// Run the saga middleware
sagaMiddleware.run(rootSaga)

// Create a persistor
const persistor = persistStore(store)

export { store, persistor }
